module.exports = __webpack_public_path__ + "static/media/report2.43d131e3.xlsx";